import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Form, CustomContainer } from "../../../atoms/DependencyHelper";
import ButtonWithIcon from "../../../atoms/buttons/buttonWithIcon/ButtonWithIcon";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import DeliveryAddress from "../../../atoms/checkoutForms/deliveryAddress/DeliveryAddress";
import DeliveryDetailsForm from "../../../atoms/newLineForms/creditCheckForms/deliveryDetailsForm/DeliveryDetailsForm";
import PersonDetails from "../../../atoms/checkoutForms/personDetails/PersonDetails";
import SpecialInstruction from "../../../atoms/checkoutForms/specialInstruction/SpecialInstruction";
import FormHeading from "../../../atoms/checkoutForms/formHeading/FormHeading";
import Image from "../../../atoms/image/image";
import ContentSearchBox from "../../../atoms/contentSearchBox/ContentSearchBox";
import ConfirmModal from "../../../atoms/confirmModal/ConfirmModal";
import {
  createCustomerAddressService,
  updateCustomerAddressService,
  setNewShippingAddressService,
  deleteCustomerAddressService,
} from "../../../../services/checkoutService";
import {
  showSpinner,
  hideSpinner,
  africaCountryCode,
} from "../../../../utils/helperServices";
import errorMessages from "../../../../config/errorMessages";
import * as Analytics from "../../../../services/analyticsUtag";
import config from "../../../../config/index";
import styles from "./CheckoutFormsModal.module.scss";

const CheckoutFormsModal = ({
  show,
  hide,
  formType,
  variant,
  values,
  addressTypes,
  statesTypes,
  countryCode,
  cartId,
  step,
  deleteOption,
  pageName,
  isGuestUser,
  applicationType,
}) => {
  const [validated, setValidated] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const addressTypesOptions = addressTypes ? addressTypes : [];
  const stateTypesOptions = statesTypes ? statesTypes : [];

  const RESIDENTIAL_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[0]
      ? addressTypesOptions[0].id
      : "";
  const BUSINESS_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[1]
      ? addressTypesOptions[1].id
      : "";
  const POSTAL_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[2]
      ? addressTypesOptions[2].id
      : "";

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmModalContent, setConfirmModalContent] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [finalAddress, setFinalAddress] = useState([]);

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const numRegEx = RegExp(/^[0-9]*$/);
  const cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
  const streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
  const emailRegEx = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

  const analyticsData = Analytics.getUtagData();

  const createStreetString = (arr) => {
    let res = "";
    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }
    return res;
  };

  const seperateStreetString = (str) => {
    if (str && str !== "") {
      return str.split(", ");
    } else {
      return null;
    }
  };

  const getRegionValue = (id) => {
    return id && id !== "" ? statesTypes.find((item) => item.id == id) : null;
  };

  const getProvinceValue = (name) => {
    var finalID = statesTypes.filter((item) => item.code == name);
    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  const createStreetFromAddressLines = (str1, str2) => {
    let res = [];
    if (str1) {
      res.push(str1);
    }

    if (str2) {
      res.push(str2);
    }
    return res;
  };

  const [state, setState] = useState({
    validationsOn: {
      delivery: false,
      billing: false,
      details: false,
      contactDetails: false,
      instructions: false,
    },
    errorStatus: {
      delivery: false,
      billing: false,
      details: false,
      contactDetails: false,
      instructions: false,
    },
    validations: {
      delivery: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
      },
      billing: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
      },
      details: {
        firstName: true,
        surName: true,
        cellNumber: true,
        email: true,
      },
      contactDetails: {
        firstName: true,
        surName: true,
        cellNumber: true,
      },
      instructions: {
        instructions: true,
      },
    },
    fieldErrors: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false,
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false,
      },
      instructions: {
        instructions: false,
      },
      fail: false,
    },
    fieldValues: {
      delivery: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
      },
      billing: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
      },
      details: {
        firstName: "",
        surName: "",
        cellNumber: "",
        email: "",
      },
      contactDetails: {
        firstName: "",
        surName: "",
        cellNumber: "",
      },
      instructions: {
        instructions: "",
      },
    },
    readOnlyValues: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false,
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false,
      },
      instructions: {
        instructions: false,
      },
    },
    fieldErrorsMessage: {
      delivery: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions",
      },
      billing: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions",
      },
      details: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter your cellphone number",
        email: "Please enter your email address",
      },
      contactDetails: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter a cellphone number",
      },
      instructions: {
        instructions: "Please enter special instructions",
      },
    },
  });

  const {
    validationsOn,
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    readOnlyValues,
    fieldErrorsMessage,
  } = state;

  function setValidationsOn() {
    if (formType) {
      validationsOn[formType] = true;
      errorStatus[formType] = checkFormError(formType);

      if (formType == "delivery") {
        if (variant !== "change") {
          validationsOn.contactDetails = true;
          errorStatus.contactDetails = checkFormError("contactDetails");
        }
      }
    }

    setState({
      ...state,
      validationsOn,
      errorStatus,
    });
  }

  function mapFormData() {
    let formData = {
      addressName: "",
      addressType: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      unitNo: "",
      complexName: "",
      streetNo: "",
      streetName: "",
      suburb: "",
      postalCode: "",
      town: "",
      province: "",
      instructions: "",
      futureCheck: false,
    };

    if (values) {
      formData.addressName = values.address_name ? values.address_name : "";
      formData.addressType = values.address_type_name
        ? values.address_type_name
        : addressTypesOptions && addressTypesOptions.length > 0
        ? addressTypesOptions[0].id
        : "";
      formData.companyName = values.company ? values.company : "";
      formData.addressLine1 =
        values.street && values.street[0] ? values.street[0] : "";
      formData.addressLine2 =
        values.street && values.street[1] ? values.street[1] : "";
      formData.unitNo = values.unit_number ? values.unit_number : "";
      formData.complexName = values.complex_name ? values.complex_name : "";
      formData.streetNo = values.street_number ? values.street_number : "";
      formData.streetName = values.street
        ? createStreetString(values.street)
        : "";
      formData.suburb = values.suburb ? values.suburb : "";
      formData.postalCode = values.postcode ? values.postcode : "";
      formData.town = values.city ? values.city : "";
      formData.province = values.region
        ? values.region.region_id
        : stateTypesOptions && stateTypesOptions.length > 0
        ? stateTypesOptions[0].id
        : "";
      formData.instructions = values.instructions ? values.instructions : "";
      formData.futureCheck = isGuestUser
        ? false
        : variant == "add" || values?.id || values?.customer_address_id
        ? true
        : false;
    }

    return formData;
  }

  useEffect(() => {
    // Set initial state of form values
    if (show) {
      if (variant == "edit" || variant == "change") {
        let formData = mapFormData();

        if (formType == "delivery" || formType == "billing") {
          fieldValues[formType].addressName = formData.addressName;
          fieldValues[formType].addressType = formData.addressType;
          fieldValues[formType].companyName = formData.companyName;
          fieldValues[formType].addressLine1 = formData.addressLine1;
          fieldValues[formType].addressLine2 = formData.addressLine2;
          fieldValues[formType].unitNo = formData.unitNo;
          fieldValues[formType].complexName = formData.complexName;
          fieldValues[formType].streetNo = formData.streetNo;
          fieldValues[formType].streetName = formData.streetName;
          fieldValues[formType].suburb = formData.suburb;
          fieldValues[formType].postalCode = formData.postalCode;
          fieldValues[formType].town = formData.town;
          fieldValues[formType].province = formData.province;
        }

        if (
          formType == "delivery" ||
          formType == "billing" ||
          formType == "instructions"
        ) {
          fieldValues[formType].instructions = formData.instructions;
        }

        if (formType == "delivery" || formType == "contactDetails") {
          fieldValues.contactDetails.firstName = values.firstname
            ? values.firstname
            : "";
          fieldValues.contactDetails.surName = values.lastname
            ? values.lastname
            : "";
          fieldValues.contactDetails.cellNumber = values.telephone
            ? values.telephone
            : "";
        } else {
          fieldValues.details.firstName = values.firstname
            ? values.firstname
            : "";
          fieldValues.details.surName = values.lastname ? values.lastname : "";
          fieldValues.details.cellNumber = values.telephone
            ? values.telephone
            : "";
        }

        fieldValues.details.email = values.email ? values.email : "";

        if (formType == "delivery" || formType == "billing") {
          validations[formType].companyName = false;
          validations[formType].addressLine1 = false;
          validations[formType].addressLine2 = false;
          validations[formType].unitNo = !!fieldValues[formType].complexName;
          validations[formType].complexName = false;
          validations[formType].streetNo = false;
          validations[formType].streetName = true;

          if (fieldValues[formType].addressType == POSTAL_ADDRESS_TYPE) {
            validations[formType].streetName = false;
            validations[formType].addressLine1 = true;
            validations[formType].addressLine2 = true;
          } else if (
            fieldValues[formType].addressType == BUSINESS_ADDRESS_TYPE
          ) {
            validations[formType].companyName = true;
            validations[formType].unitNo = true;
            validations[formType].complexName = true;
            validations[formType].streetNo = true;
          }
        }

        setState({
          ...state,
          validations,
          fieldValues,
        });
        //Button enable on edit
        setSubmitDisabled(false);
      } else {
        refreshState();
      }
      setValidationsOn();
    }
  }, [show]);

  useEffect(() => {
    addressSearchResultMap();
  }, [finalAddress]);

  var dataObject = {
    delivery: {
      title: "Delivery address",
      desc: "Where would you like us to deliver your order?",
    },
    billing: {
      title: "Billing address",
      desc: "Where would you like us to send your bill?",
    },
    details: {
      title: "Contact details",
      desc: "Who can we contact when we deliver at this address?",
    },
    contactDetails: {
      title: "Contact details",
      desc: "Who can we contact when we deliver at this address?",
    },
    instructions: {
      title: "Special instructions",
      desc: "Is there anything our courier needs to take into account when delivering your order?",
    },
  };

  var addVariantObject = {
    delivery: {
      modalTitle: "Add a delivery address",
      buttonLabel: "Save address",
    },
    billing: {
      modalTitle: "Add a billing address",
      buttonLabel: "Save address",
    },
    details: {
      modalTitle: "Add contact details",
      buttonLabel: "Save details",
    },
    contactDetails: {
      modalTitle: "Add contact details",
      buttonLabel: "Save details",
    },
    instructions: {
      modalTitle: "Add special instructions",
      buttonLabel: "Save",
    },
  };

  var editVariantObject = {
    delivery: {
      modalTitle: "Edit your delivery address",
      buttonLabel: "Update address",
    },
    billing: {
      modalTitle: "Edit your billing address",
      buttonLabel: "Update address",
    },
    details: {
      modalTitle: "Edit contact details",
      buttonLabel: "Update",
    },
    contactDetails: {
      modalTitle: "Edit contact details",
      buttonLabel: "Update",
    },
    instructions: {
      modalTitle: "Edit special instructions",
      buttonLabel: "Update",
    },
  };

  var changeVariantObject = {
    delivery: {
      modalTitle: "Change delivery address",
      buttonLabel: "Update address",
    },
    billing: {
      modalTitle: "Change billing address",
      buttonLabel: "Update address",
    },
    details: {
      modalTitle: "Change contact details",
      buttonLabel: "Update",
    },
    contactDetails: {
      modalTitle: "Change contact details",
      buttonLabel: "Update",
    },
    instructions: {
      modalTitle: "Change special instructions",
      buttonLabel: "Update",
    },
  };

  const modalClose = (refresh, results) => {
    refreshState();
    hideSpinner();
    hide(refresh, results);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();

    if (!checkEntireFormError()) {
      let linkType = getAnalyticsLinkType();
      Analytics.link({
        page_name: `${pageName}`,
        ...Analytics.getUtagData([
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        link_type: "o",
        link_name: `${pageName}: ${variant} ${linkType}: submit`,
      });
      addEditAddress();
    } else {
      event.stopPropagation();
    }
  };

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    event.persist();
    const { name } = event.target;

    await fieldValidationCheck(name, val, form, event);

    if (name === "complexName") {
      await fieldValidationCheck("unitNo", state.fieldValues[form].unitNo, form, event);
    }

    if (name == "addressType") {
      // Check form validation because field validation updated
      multipleFieldsValidationCheck(
        [
          "companyName",
          "addressLine1",
          "addressLine2",
          "unitNo",
          "complexName",
          "streetNo",
          "streetName",
        ],
        form,
        event
      );
    }

    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
    });

    if (state.fieldErrors.fail) {
      setSubmitDisabled(true);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    await updateFieldValues(event, val, form);
  };

  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    if (name == "addressType") {
      validations[form].companyName = false;
      validations[form].addressLine1 = false;
      validations[form].addressLine2 = false;
      validations[form].unitNo = false;
      validations[form].complexName = false;
      validations[form].streetNo = false;
      validations[form].streetName = true;

      if (value == POSTAL_ADDRESS_TYPE) {
        validations[form].streetName = false;
        validations[form].addressLine1 = true;
        validations[form].addressLine2 = true;

        if (
          fieldValues[form].addressLine1 == "" ||
          fieldValues[form].addressLine2 == ""
        ) {
          fieldErrors.fail = true;
        } else {
          fieldErrors.fail = false;
        }
      } else if (value == BUSINESS_ADDRESS_TYPE) {
        validations[form].companyName = true;
        validations[form].unitNo = true;
        validations[form].complexName = true;
        validations[form].streetNo = true;

        if (
          fieldValues[form].companyName == "" ||
          fieldValues[form].unitNo == "" ||
          fieldValues[form].complexName == "" ||
          fieldValues[form].streetNo == "" ||
          fieldValues[form].streetName == ""
        ) {
          fieldErrors.fail = true;
        } else {
          fieldErrors.fail = false;
        }
      }
    }

    fieldValues[form][name] = value;

    if (name == "addressType" || name == "province") {
      let selectionName = name;
      switch (name) {
        case "addressType":
          selectionName = "address type";
          break;
      }
      //capture analytics user selects addressType, province, futureCheck
      selectionAnalytics(selectionName, fieldValues[form][name]);
    }

    setState({
      ...state,
      validations,
      fieldErrors,
      fieldValues,
    });
  };

  const multipleFieldsValidationCheck = async (fieldsArray, form, event) => {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = fieldsArray.length;

    if (state.validationsOn[form]) {
      for (let i = 0; i < entries; i++) {
        if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
          fieldValidationCheck(
            fieldsArray[i],
            values[fieldsArray[i]],
            form,
            event
          );
        }
      }
    }
  };

  const fieldValidationCheck = async (name, val, form, event) => {
    const value = val ? val : event.target.value;

    switch (name) {
      case "addressName":
        if (state.validationsOn[form] && state.validations[form].addressName) {
          fieldErrors[form].addressName = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].addressName;
        } else {
          fieldErrors[form].addressName = false;
        }
        break;

      case "addressType":
        if (state.validationsOn[form] && state.validations[form].addressType) {
          fieldErrors[form].addressType = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].addressType;
        } else {
          fieldErrors.addressType = false;
        }
        break;

      case "companyName":
        if (state.validationsOn[form] && state.validations[form].companyName) {
          fieldErrors[form].companyName = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].companyName;
        } else {
          fieldErrors[form].companyName = false;
        }
        break;

      case "addressLine1":
        if (state.validationsOn[form] && state.validations[form].addressLine1) {
          fieldErrors[form].addressLine1 = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].addressLine1;
        } else {
          fieldErrors[form].addressLine1 = false;
        }
        break;

      case "addressLine2":
        if (state.validationsOn[form] && state.validations[form].addressLine2) {
          fieldErrors[form].addressLine2 = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].addressLine2;
        } else {
          fieldErrors[form].addressLine2 = false;
        }
        break;

      case "unitNo":
        if (value.length > 0) {
          fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].unitNo) {
            if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
              fieldErrorsMessage[form].unitNo =
                errorMessages.checkout[form].floorNo.onlyNumber;
            } else {
              fieldErrorsMessage[form].unitNo =
                errorMessages.checkout[form].unitNo.onlyNumber;
            }
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].unitNo) {
            fieldErrors[form].unitNo = true;
          } else {
            fieldErrors[form].unitNo = false;
          }

          if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
            fieldErrorsMessage[form].unitNo =
              errorMessages.checkout.errors.addressForm[form].floorNo;
          } else {
            fieldErrorsMessage[form].unitNo =
              errorMessages.checkout.errors.addressForm[form].unitNo;
          }
        }
        fieldErrors.fail = fieldErrors[form].unitNo;
        break;

      case "complexName":
        if (state.validationsOn[form] && state.validations[form].complexName) {
          fieldErrors[form].complexName = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].complexName;
          if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
            fieldErrorsMessage[form].complexName =
              state.fieldErrorsMessage[form].officeComplexName;
          } else {
            fieldErrorsMessage[form].complexName =
              state.fieldErrorsMessage[form].complexName;
          }
        } else {
          fieldErrors[form].complexName = false;
        }

        if(state.fieldValues[form].complexName !=="") {
          state.validations.delivery.unitNo = true;
        }
        if(state.fieldValues[form].complexName == "") {
          state.validations.delivery.unitNo = false;
        }
        break;

      case "streetNo":
        if (value.length > 0) {
          fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].streetNo) {
            fieldErrorsMessage[form].streetNo =
              errorMessages.checkout[form].streetNo.onlyValid;
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].streetNo) {
            fieldErrors[form].streetNo = true;
          } else {
            fieldErrors[form].streetNo = false;
          }

          fieldErrorsMessage[form].streetNo =
            errorMessages.checkout.errors.addressForm[form].streetNo;
        }
        fieldErrors.fail = fieldErrors[form].streetNo;
        break;

      case "streetName":
        if (state.validationsOn[form] && state.validations[form].streetName) {
          if (value.length > 0) {
            if (!streetNameRegEx.test(value)) {
              fieldErrors[form].streetName = true;
              fieldErrorsMessage[form].streetName =
                errorMessages.checkout[form].streetName.onlyValid;
            } else {
              fieldErrors[form].streetName = false;
            }
          } else {
            fieldErrors[form].streetName = true;
            fieldErrorsMessage[form].streetName =
              errorMessages.checkout.errors.addressForm[form].streetName;
          }
          fieldErrors.fail = fieldErrors[form].streetName;
        } else {
          fieldErrors[form].streetName = false;
        }
        break;

      case "suburb":
        if (state.validationsOn[form] && state.validations[form].suburb) {
          fieldErrors[form].suburb = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].suburb;
        } else {
          fieldErrors[form].suburb = false;
        }
        break;

      case "town":
        if (state.validationsOn[form] && state.validations[form].town) {
          fieldErrors[form].town = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].town;
        } else {
          fieldErrors[form].town = false;
        }
        break;

      case "postalCode":
        if (state.validationsOn[form] && state.validations[form].postalCode) {
          if (value.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.checkout[form].postalCode.onlyNumber;
            } else if (value.length < 4) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.checkout[form].postalCode.onlyValid;
            } else {
              fieldErrors[form].postalCode = false;
            }
          } else {
            fieldErrors[form].postalCode = true;
            fieldErrorsMessage[form].postalCode =
              errorMessages.checkout.errors.addressForm[form].postalCode;
          }
          fieldErrors.fail = fieldErrors[form].postalCode;
        } else {
          fieldErrors[form].postalCode = false;
        }
        break;

      case "province":
        if (state.validationsOn[form] && state.validations[form].province) {
          fieldErrors[form].province = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].province;
        } else {
          fieldErrors[form].province = false;
        }
        break;

      case "firstName":
        if (state.validationsOn[form] && state.validations[form].firstName) {
          if (value.length > 0) {
            if (value.length <= 2) {
              fieldErrors[form].firstName = true;
              fieldErrorsMessage[form].firstName =
                errorMessages.checkout[form].firstName.minCharacters;
            } else {
              fieldErrors[form].firstName = false;
            }
          } else {
            fieldErrors[form].firstName = true;
            fieldErrorsMessage[form].firstName =
              errorMessages.checkout.errors.addressForm[form].firstName;
          }
          fieldErrors.fail = fieldErrors[form].firstName;
        } else {
          fieldErrors[form].firstName = false;
        }
        break;

      case "surName":
        if (state.validationsOn[form] && state.validations[form].surName) {
          if (value.length > 0) {
            if (value.length <= 2) {
              fieldErrors[form].surName = true;
              fieldErrorsMessage[form].surName =
                errorMessages.checkout[form].surName.minCharacters;
            } else {
              fieldErrors[form].surName = false;
            }
          } else {
            fieldErrors[form].surName = true;
            fieldErrorsMessage[form].surName =
              errorMessages.checkout.errors.addressForm[form].surName;
          }
          fieldErrors.fail = fieldErrors[form].surName;
        } else {
          fieldErrors[form].surName = false;
        }
        break;

      case "cellNumber":
        if (state.validationsOn[form] && state.validations[form].cellNumber) {
          if (value.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkout[form].cellNumber.onlyNumber;
            } else if (!cellPhoneRegEx.test(value)) {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkout[form].cellNumber.startWith;
            } else if (africaCountryCode(value) && value.length < 11) {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkout.errors.addressForm[form].cellNumber;
            } else if (value.length < 10) {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkout.errors.addressForm[form].cellNumber;
            } else {
              fieldErrors[form].cellNumber = false;
            }
          } else {
            fieldErrors[form].cellNumber = true;
            fieldErrorsMessage[form].cellNumber =
              errorMessages.checkout.errors.addressForm[form].cellNumber;
          }
          fieldErrors.fail = fieldErrors[form].cellNumber;
        } else {
          fieldErrors[form].cellNumber = false;
        }
        break;

      case "email":
        if (state.validationsOn[form] && state.validations[form].email) {
          if (value.length > 0) {
            fieldErrors[form].email = emailRegEx.test(value) ? false : true;
            if (fieldErrors[form].email) {
              fieldErrorsMessage.email =
                errorMessages.checkout[form].email.onlyValid;
            }
          } else {
            fieldErrors[form].email = true;
            fieldErrorsMessage[form].email =
              errorMessages.checkout.errors.addressForm[form].email;
          }
          fieldErrors.fail = fieldErrors[form].email;
        } else {
          fieldErrors[form].email = false;
        }
        break;

      case "instructions":
        if (state.validationsOn[form] && state.validations[form].instructions) {
          fieldErrors[form].instructions = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].instructions;
        } else {
          fieldErrors[form].instructions = false;
        }
        break;
    }

    setState({
      ...state,
      fieldErrors,
      fieldErrorsMessage,
    });
  };

  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change
   */
  const selectionAnalytics = (selectionType, value) => {
    let linkType = getAnalyticsLinkType();

    Analytics.link({
      page_name: `${pageName}`,
      ...Analytics.getUtagData([
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
      ]),
      visitor_subscription_type:
        applicationType == "normal"
          ? analyticsData.visitor_subscription_type
          : "postpaid",
      page_tool_event: "use",
      page_tool_name: `${pageName}: ${variant} ${linkType}: ${selectionType}`,
      filter_query: value,
    });
  };

  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (const err of errValues) {
      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  function checkEntireFormError() {
    var entries = Object.entries(state.validationsOn);

    for (const [key, value] of entries) {
      if (value) {
        return checkFormError(key);
      }
      return false;
    }
  }

  const addressSearchResultMap = async () => {
    const localityType = finalAddress.address_components;
    if (localityType && localityType.length > 0) {
      await mapAddressSearchData(localityType);

      errorStatus[formType] = await checkFormError(formType);
      setState({
        ...state,
        errorStatus,
      });

      if (errorStatus[formType]) {
        setSubmitDisabled(true);
      } else {
        checkErrorStatus();
      }
    }
  };

  const mapAddressSearchData = async (localityType) => {
    readOnlyValues[formType].postalCode = false;

    fieldValues[formType].unitNo = "";
    fieldValues[formType].complexName = "";
    fieldValues[formType].streetNo = "";
    fieldValues[formType].streetName = "";
    fieldValues[formType].suburb = "";
    fieldValues[formType].province = "";
    fieldValues[formType].town = "";
    fieldValues[formType].postalCode = "";

    fieldErrors[formType].unitNo = false;
    fieldErrors[formType].complexName = false;
    fieldErrors[formType].streetNo = false;
    fieldErrors[formType].streetName = false;
    fieldErrors[formType].suburb = false;
    fieldErrors[formType].province = false;
    fieldErrors[formType].town = false;
    fieldErrors[formType].postalCode = false;

    for (let i = 0; i < localityType.length; i++) {
      if (localityType[i].administrative_type == "unit") {
        if (localityType[i].long_name) {
          fieldValues[formType].unitNo = localityType[i].long_name;
        }
      }

      if (localityType[i].administrative_type == "building") {
        fieldValues[formType].complexName = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == "street_number") {
        fieldValues[formType].streetNo = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == "route") {
        fieldValues[formType].streetName = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == "suburb") {
        fieldValues[formType].suburb = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == "province") {
        fieldValues[formType].province = getProvinceValue(
          localityType[i].long_name
        );
      }

      if (
        localityType[i].administrative_type == "town" ||
        localityType[i].administrative_type == "city"
      ) {
        fieldValues[formType].town = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == "post_street") {
        if (localityType[i].long_name.length > 0) {
          readOnlyValues[formType].postalCode = true;
        }
        fieldValues[formType].postalCode = localityType[i].long_name;
      }
    }

    setState({
      ...state,
      readOnlyValues,
      fieldValues,
      fieldErrors,
    });
  };

  const mapContactFormData = () => {
    let contactData = { firstName: "", surName: "", cellNumber: "" };

    if (formType == "delivery" || formType == "contactDetails") {
      contactData.firstName =
        state.fieldValues["contactDetails"].firstName !== ""
          ? state.fieldValues["contactDetails"].firstName
          : "";
      contactData.surName =
        state.fieldValues["contactDetails"].surName !== ""
          ? state.fieldValues["contactDetails"].surName
          : "";
      contactData.cellNumber =
        state.fieldValues["contactDetails"].cellNumber !== ""
          ? state.fieldValues["contactDetails"].cellNumber
          : "";
    } else {
      contactData.firstName =
        state.fieldValues["details"].firstName !== ""
          ? state.fieldValues["details"].firstName
          : "";
      contactData.surName =
        state.fieldValues["details"].surName !== ""
          ? state.fieldValues["details"].surName
          : "";
      contactData.cellNumber =
        state.fieldValues["details"].cellNumber !== ""
          ? state.fieldValues["details"].cellNumber
          : "";
    }

    return contactData;
  };

  const mapFieldData = () => {
    let formData = mapFormData();
    let contactFormData = mapContactFormData();
    let newValues =
      formType == "delivery" || formType == "billing"
        ? state.fieldValues[formType]
        : formData;
    let regionValue = getRegionValue(newValues.province);
    let newStreetName = null;

    if (formType == "delivery" || formType == "billing") {
      newStreetName =
        newValues.streetName !== "" && state.validations[formType].streetName
          ? seperateStreetString(newValues.streetName)
          : newValues.addressLine1 !== "" &&
            newValues.addressLine2 !== "" &&
            state.validations[formType].addressLine1 &&
            state.validations[formType].addressLine2
          ? createStreetFromAddressLines(
              newValues.addressLine1,
              newValues.addressLine2
            )
          : null;
    } else {
      newStreetName =
        newValues.streetName !== ""
          ? seperateStreetString(newValues.streetName)
          : newValues.addressLine1 !== "" && newValues.addressLine2 !== ""
          ? createStreetFromAddressLines(
              newValues.addressLine1,
              newValues.addressLine2
            )
          : null;
    }

    return {
      id: values.id ? values.id : null,
      region_id: regionValue && regionValue.id ? regionValue.id : null,
      region_code: regionValue && regionValue.code ? regionValue.code : null,
      region: regionValue && regionValue.name ? regionValue.name : null,
      country_code: countryCode ? countryCode : null,
      instructions:
        newValues.instructions !== "" ? newValues.instructions : null,
      street: newStreetName,
      postcode: newValues.postalCode !== "" ? newValues.postalCode : null,
      city: newValues.town !== "" ? newValues.town : null,
      address_type_name:
        newValues.addressType !== "" ? newValues.addressType : null,
      address_name: newValues.addressName !== "" ? newValues.addressName : null,
      company: newValues.companyName !== "" ? newValues.companyName : null,
      unit_number: newValues.unitNo !== "" ? newValues.unitNo : null,
      complex_name: newValues.complexName !== "" ? newValues.complexName : null,
      street_number: newValues.streetNo !== "" ? newValues.streetNo : null,
      suburb: newValues.suburb !== "" ? newValues.suburb : null,
      firstname: contactFormData.firstName,
      lastname: contactFormData.surName,
      telephone: contactFormData.cellNumber,
      email:
        state.fieldValues["details"].email !== ""
          ? state.fieldValues["details"].email
          : null,
      save_in_address_book: formData.futureCheck,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: values.is_shipping_address
        ? values.is_shipping_address
        : 0,
      is_billing_address: values.is_billing_address
        ? values.is_billing_address
        : 0,
    };
  };

  const refreshState = () => {
    validationsOn.delivery = false;
    validationsOn.billing = false;
    validationsOn.details = false;
    validationsOn.contactDetails = false;
    validationsOn.instructions = false;

    errorStatus.delivery = false;
    errorStatus.billing = false;
    errorStatus.details = false;
    errorStatus.contactDetails = false;
    errorStatus.instructions = false;

    validations.delivery.addressName = true;
    validations.delivery.addressType = true;
    validations.delivery.companyName = false;
    validations.delivery.addressLine1 = false;
    validations.delivery.addressLine2 = false;
    validations.delivery.unitNo = false;
    validations.delivery.complexName = false;
    validations.delivery.streetNo = false;
    validations.delivery.streetName = true;
    validations.delivery.suburb = true;
    validations.delivery.postalCode = true;
    validations.delivery.town = true;
    validations.delivery.province = true;
    validations.delivery.instructions = false;

    validations.billing.addressName = true;
    validations.billing.addressType = true;
    validations.billing.companyName = false;
    validations.billing.addressLine1 = false;
    validations.billing.addressLine2 = false;
    validations.billing.unitNo = false;
    validations.billing.complexName = false;
    validations.billing.streetNo = false;
    validations.billing.streetName = true;
    validations.billing.suburb = true;
    validations.billing.postalCode = true;
    validations.billing.town = true;
    validations.billing.province = true;
    validations.billing.instructions = false;

    validations.details.firstName = true;
    validations.details.surName = true;
    validations.details.cellNumber = true;
    validations.details.email = true;

    validations.contactDetails.firstName = true;
    validations.contactDetails.surName = true;
    validations.contactDetails.cellNumber = true;

    validations.instructions.instructions = true;

    fieldErrors.delivery.addressName = false;
    fieldErrors.delivery.addressType = false;
    fieldErrors.delivery.companyName = false;
    fieldErrors.delivery.addressLine1 = false;
    fieldErrors.delivery.addressLine2 = false;
    fieldErrors.delivery.unitNo = false;
    fieldErrors.delivery.complexName = false;
    fieldErrors.delivery.streetNo = false;
    fieldErrors.delivery.streetName = false;
    fieldErrors.delivery.suburb = false;
    fieldErrors.delivery.postalCode = false;
    fieldErrors.delivery.town = false;
    fieldErrors.delivery.province = false;
    fieldErrors.delivery.instructions = false;

    fieldErrors.billing.addressName = false;
    fieldErrors.billing.addressType = false;
    fieldErrors.billing.companyName = false;
    fieldErrors.billing.addressLine1 = false;
    fieldErrors.billing.addressLine2 = false;
    fieldErrors.billing.unitNo = false;
    fieldErrors.billing.complexName = false;
    fieldErrors.billing.streetNo = false;
    fieldErrors.billing.streetName = false;
    fieldErrors.billing.suburb = false;
    fieldErrors.billing.postalCode = false;
    fieldErrors.billing.town = false;
    fieldErrors.billing.province = false;
    fieldErrors.billing.instructions = false;

    fieldErrors.details.firstName = false;
    fieldErrors.details.surName = false;
    fieldErrors.details.cellNumber = false;
    fieldErrors.details.email = false;

    fieldErrors.contactDetails.firstName = false;
    fieldErrors.contactDetails.surName = false;
    fieldErrors.contactDetails.cellNumber = false;

    fieldErrors.instructions.instructions = false;
    fieldErrors.fail = false;

    fieldValues.delivery.addressName = "";
    fieldValues.delivery.addressType = RESIDENTIAL_ADDRESS_TYPE;
    fieldValues.delivery.companyName = "";
    fieldValues.delivery.addressLine1 = "";
    fieldValues.delivery.addressLine2 = "";
    fieldValues.delivery.unitNo = "";
    fieldValues.delivery.complexName = "";
    fieldValues.delivery.streetNo = "";
    fieldValues.delivery.streetName = "";
    fieldValues.delivery.suburb = "";
    fieldValues.delivery.postalCode = "";
    fieldValues.delivery.town = "";
    fieldValues.delivery.province =
      stateTypesOptions && stateTypesOptions.length > 0
        ? stateTypesOptions[0].id
        : "";
    fieldValues.delivery.instructions = "";

    fieldValues.billing.addressName = "";
    fieldValues.billing.addressType = RESIDENTIAL_ADDRESS_TYPE;
    fieldValues.billing.companyName = "";
    fieldValues.billing.addressLine1 = "";
    fieldValues.billing.addressLine2 = "";
    fieldValues.billing.unitNo = "";
    fieldValues.billing.complexName = "";
    fieldValues.billing.streetNo = "";
    fieldValues.billing.streetName = "";
    fieldValues.billing.suburb = "";
    fieldValues.billing.postalCode = "";
    fieldValues.billing.town = "";
    fieldValues.billing.province =
      stateTypesOptions && stateTypesOptions.length > 0
        ? stateTypesOptions[0].id
        : "";
    fieldValues.billing.instructions = "";

    fieldValues.details.firstName = values.firstName ? values.firstName : "";
    fieldValues.details.surName = values.surName ? values.surName : "";
    fieldValues.details.cellNumber = values.cellNumber ? values.cellNumber : "";
    fieldValues.details.email = "";

    fieldValues.contactDetails.firstName = "";
    fieldValues.contactDetails.surName = "";
    fieldValues.contactDetails.cellNumber = "";

    fieldValues.instructions.instructions = "";

    readOnlyValues.delivery.addressName = false;
    readOnlyValues.delivery.addressType = false;
    readOnlyValues.delivery.companyName = false;
    readOnlyValues.delivery.addressLine1 = false;
    readOnlyValues.delivery.addressLine2 = false;
    readOnlyValues.delivery.unitNo = false;
    readOnlyValues.delivery.complexName = false;
    readOnlyValues.delivery.streetNo = false;
    readOnlyValues.delivery.streetName = false;
    readOnlyValues.delivery.suburb = false;
    readOnlyValues.delivery.postalCode = false;
    readOnlyValues.delivery.town = false;
    readOnlyValues.delivery.province = false;
    readOnlyValues.delivery.instructions = false;

    readOnlyValues.billing.addressName = false;
    readOnlyValues.billing.addressType = false;
    readOnlyValues.billing.companyName = false;
    readOnlyValues.billing.addressLine1 = false;
    readOnlyValues.billing.addressLine2 = false;
    readOnlyValues.billing.unitNo = false;
    readOnlyValues.billing.complexName = false;
    readOnlyValues.billing.streetNo = false;
    readOnlyValues.billing.streetName = false;
    readOnlyValues.billing.suburb = false;
    readOnlyValues.billing.postalCode = false;
    readOnlyValues.billing.town = false;
    readOnlyValues.billing.province = false;
    readOnlyValues.billing.instructions = false;

    readOnlyValues.details.firstName = false;
    readOnlyValues.details.surName = false;
    readOnlyValues.details.cellNumber = false;
    readOnlyValues.details.email = false;

    readOnlyValues.contactDetails.firstName = false;
    readOnlyValues.contactDetails.surName = false;
    readOnlyValues.contactDetails.cellNumber = false;

    readOnlyValues.instructions.instructions = false;

    fieldErrorsMessage.delivery.addressName =
      "Please enter a name for this address";
    fieldErrorsMessage.delivery.addressType = "Please select your address type";
    fieldErrorsMessage.delivery.companyName = "Please enter your company name";
    fieldErrorsMessage.delivery.addressLine1 =
      "Please enter your postal address (Line 1)";
    fieldErrorsMessage.delivery.addressLine2 =
      "Please enter your postal address (Line 2)";
    fieldErrorsMessage.delivery.unitNo = "Please enter a unit no.";
    fieldErrorsMessage.delivery.complexName = "Please enter your complex name";
    fieldErrorsMessage.delivery.streetNo = "Please enter your street no.";
    fieldErrorsMessage.delivery.streetName = "Please enter your street name";
    fieldErrorsMessage.delivery.suburb = "Please enter and select your suburb";
    fieldErrorsMessage.delivery.postalCode = "Please enter your postal code";
    fieldErrorsMessage.delivery.town = "Please enter your town/city name";
    fieldErrorsMessage.delivery.province = "Please select your province";
    fieldErrorsMessage.delivery.instructions =
      "Please enter special instructions";

    fieldErrorsMessage.billing.addressName =
      "Please enter a name for this address";
    fieldErrorsMessage.billing.addressType = "Please select your address type";
    fieldErrorsMessage.billing.companyName = "Please enter your company name";
    fieldErrorsMessage.billing.addressLine1 =
      "Please enter your postal address (Line 1)";
    fieldErrorsMessage.billing.addressLine2 =
      "Please enter your postal address (Line 2)";
    fieldErrorsMessage.billing.unitNo = "Please enter a unit no.";
    fieldErrorsMessage.billing.complexName = "Please enter your complex name";
    fieldErrorsMessage.billing.streetNo = "Please enter your street no.";
    fieldErrorsMessage.billing.streetName = "Please enter your street name";
    fieldErrorsMessage.billing.suburb = "Please enter and select your suburb";
    fieldErrorsMessage.billing.postalCode = "Please enter your postal code";
    fieldErrorsMessage.billing.town = "Please enter your town/city name";
    fieldErrorsMessage.billing.province = "Please select your province";
    fieldErrorsMessage.billing.instructions =
      "Please enter special instructions";

    fieldErrorsMessage.details.firstName = "Please enter your first name";
    fieldErrorsMessage.details.surName = "Please enter your surname";
    fieldErrorsMessage.details.cellNumber =
      "Please enter your cellphone number";
    fieldErrorsMessage.details.email = "Please enter your email address";

    fieldErrorsMessage.contactDetails.firstName = "Please enter a first name";
    fieldErrorsMessage.contactDetails.surName = "Please enter your surname";
    fieldErrorsMessage.contactDetails.cellNumber =
      "Please enter a cellphone number";

    fieldErrorsMessage.instructions.instructions =
      "Please enter special instructions";

    setValidated(false);
    setSubmitDisabled(true);
    setShowConfirmModal(false);
    setConfirmModalContent("");
    setDeleteId(null);

    setState({
      ...state,
      validationsOn,
      errorStatus,
      validations,
      fieldErrors,
      fieldValues,
      fieldErrorsMessage,
    });
  };

  function getAnalyticsLinkType() {
    let linkType = formType + " address";

    if (formType == "details" || formType == "contactDetails") {
      linkType =
        applicationType == "normal" ? "contact person" : "contact details";
    } else if (formType == "instructions") {
      linkType = "special instructions";
    }

    return linkType;
  }

  const addEditAddress = async () => {
    var inputAddressObj = mapFieldData();

    let linkType = getAnalyticsLinkType();

    if (variant == "add") {
      if (applicationType == "normal") {
        if (formType == "delivery") {
          inputAddressObj.is_shipping_address = 1;
        } else if (formType == "billing") {
          inputAddressObj.is_billing_address = 1;
        }
      } else {
        inputAddressObj.is_shipping_address = 1;
        inputAddressObj.is_billing_address = 1;
        inputAddressObj.same_as_shipping = true;
      }

      try {
        showSpinner();
        let results = await createCustomerAddressService(inputAddressObj);

        if (!results.fail) {
          Analytics.link({
            page_name: `${pageName}`,
            ...Analytics.getUtagData([
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
            ]),
            visitor_subscription_type:
              applicationType == "normal"
                ? analyticsData.visitor_subscription_type
                : "postpaid",
            page_form_event: "success",
            page_form_name: `${pageName}: ${variant} ${linkType}`,
          });
        } else {
          Analytics.link({
            page_name: `${pageName}`,
            ...Analytics.getUtagData([
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
            ]),
            visitor_subscription_type:
              applicationType == "normal"
                ? analyticsData.visitor_subscription_type
                : "postpaid",
            page_form_event: "errors",
            page_form_name: `${pageName}: ${variant} ${linkType}`,
            page_errors: results?.errors?.[0]?.message,
          });
        }

        modalClose(!results.fail, results);
      } catch {
        modalClose();
      }
    } else {
      try {
        showSpinner();
        let results = "";
        inputAddressObj.id = values.id ? values.id : values.customer_address_id;

        if (inputAddressObj.id) {
          results = await updateCustomerAddressService(inputAddressObj);

          if (!results.fail) {
            Analytics.link({
              page_name: `${pageName}`,
              ...Analytics.getUtagData([
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "success",
              page_form_name: `${pageName}: ${variant} ${linkType}`,
            });
          } else {
            Analytics.link({
              page_name: `${pageName}`,
              ...Analytics.getUtagData([
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "errors",
              page_form_name: `${pageName}: ${variant} ${linkType}`,
              page_errors: results?.errors?.[0]?.message,
            });
          }
        } else {
          inputAddressObj.cart_id = cartId !== "" ? cartId : null;
          inputAddressObj.region = inputAddressObj.region_code;
          results = await setNewShippingAddressService(inputAddressObj);

          if (!results.fail) {
            Analytics.link({
              page_name: `${pageName}`,
              ...Analytics.getUtagData([
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "success",
              page_form_name: `${pageName}: ${variant} ${linkType}`,
            });
          } else {
            Analytics.link({
              page_name: `${pageName}`,
              ...Analytics.getUtagData([
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "errors",
              page_form_name: `${pageName}: ${variant} ${linkType}`,
              page_errors: results?.errors?.[0]?.message,
            });
          }
        }

        modalClose(!results.fail, results);
      } catch {
        modalClose();
      }
    }
  };

  const displyConfirmModal = () => {
    let newData = {
      id: values.id,
      name: values && values.address_name ? values.address_name : null,
      street:
        values &&
        values.street_number &&
        values.street_number != "" &&
        values.street
          ? values.street_number + ", " + createStreetString(values.street)
          : values.street_number && values.street_number != ""
          ? values.street_number
          : values.street
          ? createStreetString(values.street)
          : null,
      suburb: values && values.suburb ? values.suburb : null,
      postcode: values && values.postcode ? values.postcode : null,
    };

    var nameHTML =
      '<div class="' +
      styles["value"] +
      '"><span class="' +
      styles["value__first"] +
      '">' +
      newData.name +
      "</span>";

    var streetHTML = "";

    if (newData.street && newData.suburb && newData.postcode) {
      streetHTML =
        '<span class="' +
        styles["value__second"] +
        '">' +
        newData.street +
        ", " +
        newData.suburb +
        ", " +
        newData.postcode +
        "</span>";
    } else if (newData.suburb && newData.postcode) {
      streetHTML =
        '<span class="' +
        styles["value__second"] +
        '">' +
        newData.suburb +
        ", " +
        newData.postcode +
        "</span>";
    }

    var closeHTML = "</div>";

    var contentHTML =
      streetHTML !== ""
        ? nameHTML + streetHTML + closeHTML
        : nameHTML + closeHTML;

    setConfirmModalContent(contentHTML);
    setDeleteId(newData.id);
    setShowConfirmModal(true);
  };

  const cancelConfirmModel = () => {
    setShowConfirmModal(false);
  };

  const approveConfirmModel = async () => {
    setShowConfirmModal(false);

    try {
      showSpinner();
      let results = await deleteCustomerAddressService(deleteId);
      modalClose(!results.fail, results);
    } catch {
      modalClose();
    }
  };

  return (
    <>
      <Modal
        dialogClassName={`${styles[formType]} ${styles["checkout-forms-modal"]}`}
        show={show}
        onHide={modalClose}
        animation={false}
      >
        <ButtonWithIcon
          className={styles["back-button"]}
          labelText="Back"
          img_url_inactive={`${imagePrefix}/assets/images/caret-back.svg`}
          img_url_active={`${imagePrefix}/assets/images/caret-back.svg`}
          clickHandler={modalClose}
        />
        <Modal.Header>
          <Modal.Title
            className={styles["modal-title"]}
            id="change-contact-details-title"
          >
            {variant == "add"
              ? addVariantObject[formType].modalTitle
              : variant == "edit"
              ? editVariantObject[formType].modalTitle
              : changeVariantObject[formType].modalTitle}
          </Modal.Title>
          <Image
            className={styles["close-button"]}
            img_path={`${imagePrefix}/assets/images/modal-close.svg`}
            onClick={modalClose}
          />
        </Modal.Header>

        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          className={styles["form"]}
        >
          <Modal.Body className={styles["modal-body"]}>
            {(formType == "delivery" || formType == "billing") && (
              <>
                <FormHeading
                  title={dataObject[formType].title}
                  desc={dataObject[formType].desc}
                ></FormHeading>
                <CustomContainer className={`${"d-none " + styles["search-wrapper"]}`}>
                  {state.fieldValues[formType].addressType !==
                    POSTAL_ADDRESS_TYPE && (
                    <ContentSearchBox
                      className={styles["search-wrapper__input"]}
                      placeholderText="Search for your address"
                      icon="blue"
                      variant="address-search"
                      setFinalAddress={setFinalAddress}
                    ></ContentSearchBox>
                  )}
                </CustomContainer>
                {step !== "creditCheck" && (
                  <DeliveryAddress
                    formName={formType}
                    variant="popup"
                    status={variant}
                    validations={state.validations[formType]}
                    fieldValues={state.fieldValues[formType]}
                    fieldErrors={state.fieldErrors[formType]}
                    fieldErrorsMessage={state.fieldErrorsMessage[formType]}
                    readOnlyValues={state.readOnlyValues[formType]}
                    stateTypesOptions={stateTypesOptions}
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    containerClassName={styles["section"]}
                  ></DeliveryAddress>
                )}
                {step == "creditCheck" && (
                  <DeliveryDetailsForm
                    formName={formType}
                    variant="popup"
                    validations={state.validations[formType]}
                    fieldValues={state.fieldValues[formType]}
                    fieldErrors={state.fieldErrors[formType]}
                    fieldErrorsMessage={state.fieldErrorsMessage[formType]}
                    readOnlyValues={state.readOnlyValues[formType]}
                    addressTypesOptions={addressTypesOptions}
                    stateTypesOptions={stateTypesOptions}
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    containerClassName={styles["section"]}
                  ></DeliveryDetailsForm>
                )}
                {formType == "delivery" && variant !== "change" && (
                  <>
                    <FormHeading
                      title={dataObject.contactDetails.title}
                      desc={dataObject.contactDetails.desc}
                    ></FormHeading>
                    <PersonDetails
                      formName="contactDetails"
                      variant="popup"
                      fieldValues={state.fieldValues["contactDetails"]}
                      fieldErrors={state.fieldErrors["contactDetails"]}
                      fieldErrorsMessage={
                        state.fieldErrorsMessage["contactDetails"]
                      }
                      readOnlyValues={state.readOnlyValues["contactDetails"]}
                      onChangeHandler={handleChange}
                      onBlurHandler={handleBlur}
                      className={styles["section"]}
                    ></PersonDetails>
                  </>
                )}
              </>
            )}
            {formType == "details" && (
              <>
                <FormHeading
                  title={dataObject.details.title}
                  desc={dataObject.details.desc}
                ></FormHeading>
                <PersonDetails
                  formName="details"
                  variant="popup"
                  fieldValues={state.fieldValues["details"]}
                  fieldErrors={state.fieldErrors["details"]}
                  fieldErrorsMessage={state.fieldErrorsMessage["details"]}
                  readOnlyValues={state.readOnlyValues["details"]}
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  className={styles["section"]}
                ></PersonDetails>
              </>
            )}
            {formType == "contactDetails" && (
              <>
                <FormHeading
                  title={dataObject.contactDetails.title}
                  desc={dataObject.contactDetails.desc}
                ></FormHeading>
                <PersonDetails
                  formName="contactDetails"
                  variant="popup"
                  fieldValues={state.fieldValues["contactDetails"]}
                  fieldErrors={state.fieldErrors["contactDetails"]}
                  fieldErrorsMessage={
                    state.fieldErrorsMessage["contactDetails"]
                  }
                  readOnlyValues={state.readOnlyValues["contactDetails"]}
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  className={styles["section"]}
                ></PersonDetails>
              </>
            )}
            {formType == "instructions" && (
              <>
                <FormHeading
                  title={dataObject.instructions.title}
                  desc={dataObject.instructions.desc}
                ></FormHeading>
                <SpecialInstruction
                  formName="instructions"
                  variant="popup"
                  fieldValues={state.fieldValues["instructions"]}
                  fieldErrors={state.fieldErrors["instructions"]}
                  fieldErrorsMessage={state.fieldErrorsMessage["instructions"]}
                  readOnlyValues={state.readOnlyValues["instructions"]}
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  className={styles["section"]}
                ></SpecialInstruction>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {variant == "edit" && deleteOption && (
              <div
                className={styles["delete-button"]}
                onClick={displyConfirmModal}
              >
                <img
                  src={`${imagePrefix}/assets/images/icon-trash-red.svg`}
                  width={18}
                  height={18}
                  className={styles["image"]}
                />
                <label>Delete this address</label>
              </div>
            )}
            <CTAButton
              type="submit"
              className={styles["button"]}
              variant="solid grey"
              disabled={submitDisabled}
              id="validationFormsb101"
            >
              {variant == "add"
                ? addVariantObject[formType].buttonLabel
                : variant == "edit"
                ? editVariantObject[formType].buttonLabel
                : changeVariantObject[formType].buttonLabel}
            </CTAButton>
            <CTAButton
              type="reset"
              className={styles["button"]}
              handleClick={modalClose}
              variant="outline black"
              id="validationFormsb102"
            >
              Cancel
            </CTAButton>
          </Modal.Footer>
        </Form>
      </Modal>
      {showConfirmModal ? (
        <ConfirmModal
          show={showConfirmModal}
          subtext="You’re about to delete this address:"
          text={confirmModalContent}
          handleConfirm={approveConfirmModel}
          handleCancel={cancelConfirmModel}
          confirmLabel="Yes, delete this address"
        />
      ) : null}
    </>
  );
};

CheckoutFormsModal.propTypes = {
  show: PropTypes.bool,
  formType: PropTypes.oneOf([
    "delivery",
    "billing",
    "details",
    "contactDetails",
    "instructions",
  ]),
  variant: PropTypes.oneOf(["add", "edit", "change"]),
  addressTypes: PropTypes.array,
  statesTypes: PropTypes.array,
  countryCode: PropTypes.string,
  countryName: PropTypes.string,
  cartId: PropTypes.string,
  step: PropTypes.string,
  deleteOption: PropTypes.bool,
  pageName: PropTypes.string,
  isGuestUser: PropTypes.bool,
  applicationType: PropTypes.string,
};

CheckoutFormsModal.defaultProps = {
  show: false,
  formType: "delivery",
  variant: "add",
  addressTypes: [],
  statesTypes: [],
  deleteOption: true,
  pageName: "checkout: ec",
  isGuestUser: false,
  applicationType: "normal",
};

export default CheckoutFormsModal;
